export default "__VITE_ASSET__e09558b8__"